import { FooterPublic } from 'components/layout';
import { ReactNode } from 'react';

export default function LayoutPublic({ children }: { children: ReactNode }) {
  return (
    <div className="grid h-screen grid-rows-segments-1fr-auto">
      <div className="grid w-full grid-cols-1 mx-auto max-w-screen-segments-1440px">
        {children}
      </div>
      <FooterPublic />
    </div>
  );
}
